import { render, staticRenderFns } from "./component.vue?vue&type=template&id=d4e8d7f2&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e8d7f2')) {
      api.createRecord('d4e8d7f2', component.options)
    } else {
      api.reload('d4e8d7f2', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=d4e8d7f2&", function () {
      api.rerender('d4e8d7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/help-desk/component.vue"
export default component.exports